import React from 'react';

export default function AuthShell({ children }) {
  return (
    <div className="login-shell">
      <div className="login-left">
        <svg viewBox="0 0 480 800" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" preserveAspectRatio="xMidYMid slice">
          <line x1="0" y1="160" x2="480" y2="420" stroke="rgba(37,157,184,0.06)" strokeWidth="1"/>
          <line x1="0" y1="260" x2="480" y2="520" stroke="rgba(37,157,184,0.04)" strokeWidth="1"/>
          <line x1="220" y1="0" x2="420" y2="800" stroke="rgba(255,255,255,0.02)" strokeWidth="1"/>
          <line x1="100" y1="0" x2="360" y2="800" stroke="rgba(255,255,255,0.015)" strokeWidth="1"/>
          <circle cx="360" cy="120" r="130" fill="none" stroke="rgba(37,157,184,0.06)" strokeWidth="1"/>
          <circle cx="360" cy="120" r="82" fill="none" stroke="rgba(37,157,184,0.09)" strokeWidth="0.5"/>
          <circle cx="360" cy="120" r="42" fill="rgba(37,157,184,0.04)" stroke="rgba(37,157,184,0.12)" strokeWidth="0.5"/>
          <circle cx="360" cy="120" r="4" fill="rgba(110,198,216,0.45)"/>
          <polygon points="50,380 100,310 155,380 100,450" fill="none" stroke="rgba(255,255,255,0.04)" strokeWidth="0.5"/>
          <polygon points="290,510 360,440 430,510 360,580" fill="none" stroke="rgba(37,157,184,0.06)" strokeWidth="0.5"/>
          <line x1="100" y1="310" x2="360" y2="120" stroke="rgba(110,198,216,0.04)" strokeWidth="0.5" strokeDasharray="5 10"/>
          <circle cx="44" cy="220" r="2.5" fill="rgba(255,255,255,0.14)"/>
          <circle cx="400" cy="380" r="2" fill="rgba(110,198,216,0.3)"/>
          <circle cx="130" cy="560" r="2" fill="rgba(255,255,255,0.1)"/>
          <circle cx="310" cy="650" r="2.5" fill="rgba(110,198,216,0.18)"/>
          <circle cx="60" cy="700" r="1.5" fill="rgba(255,255,255,0.08)"/>
          <rect x="30" y="680" width="64" height="64" rx="2" fill="none" stroke="rgba(255,255,255,0.03)" strokeWidth="0.5" transform="rotate(18,62,712)"/>
        </svg>
        <div className="login-quote">
          <blockquote>"Caring for our loved ones is one of the most meaningful things we can do."</blockquote>
          <cite>Home Care Associates of MI</cite>
        </div>
      </div>

      <div className="login-right">
        <div className="login-form-wrap">
          {children}
        </div>
      </div>
    </div>
  );
}
